import React from 'react';
import { useTranslation } from 'react-i18next';
import { CommonDialog } from 'src/components/shared/dialog/CommonDialog';

interface FollowResultDialogProps {
  action: 'follow' | 'unfollow';
}

export const FollowSucceededDialog: React.FC<FollowResultDialogProps> = ({ action }) => {
  const { t } = useTranslation('resort');
  const title = action === 'follow' ? t('dialog_follow_success') : t('dialog_unfollow_success');
  const description =
    action === 'follow' ? t('dialog_follow_success_desc') : t('dialog_unfollow_success_desc');
  return <CommonDialog title={title} description={description} />;
};
